import type { IconNode } from '../types';

/**
 * @name iron-off
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuOSA3LjNDMTEuNCA0IDguNyAyIDggMiIgLz4KICA8cGF0aCBkPSJNMjIgMTYuM1Y4YTIgMiAwIDAgMC00IDB2NC4zIiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTYgMTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMCAxMWguMDEiIC8+CiAgPHBhdGggZD0iTTYgMTVoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMCAxNWguMDEiIC8+CiAgPHBhdGggZD0iTTQuNyA0LjdDMy4zIDYuNCAyIDkgMiAxMnY3aDEydi01IiAvPgogIDxwYXRoIGQ9Ik0zIDIyaDEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/iron-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ironOff: IconNode = [
  ['path', { d: 'M12.9 7.3C11.4 4 8.7 2 8 2', key: '1o7y04' }],
  ['path', { d: 'M22 16.3V8a2 2 0 0 0-4 0v4.3', key: '15ihux' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M6 11h.01', key: 'zu6c92' }],
  ['path', { d: 'M10 11h.01', key: 'd2at3l' }],
  ['path', { d: 'M6 15h.01', key: 'ectzsy' }],
  ['path', { d: 'M10 15h.01', key: '44in9x' }],
  ['path', { d: 'M4.7 4.7C3.3 6.4 2 9 2 12v7h12v-5', key: '11f8oa' }],
  ['path', { d: 'M3 22h10', key: 's0j7d9' }],
];

export default ironOff;
